import {
  useNotification,
  useResolverEffect,
  useTest
} from '@enisco/mcc-react-lib'
import {hardlink as hardlinkMock} from './util/testData'
import {Hardlink} from './model/hardlinks'
import {AppId} from './model/apps'
import {useParams} from 'react-router-dom'
import {useIntl} from 'react-intl'
import useCurrentApp from './hooks/useCurrentApp'
import AppLauncher from './components/app-launcher/AppLauncher'

export const HardlinkApp = () => {
  const intl = useIntl()
  const test = useTest()
  const sendNotification = useNotification()
  const {hardlink} = useParams()
  const [, setCurrentApp] = useCurrentApp()

  useResolverEffect('mcc-portal-api', '/internal/hardlinks/' + hardlink, {
    options: {
      cache: 'no-cache'
    },
    mockedData: test ? JSON.stringify(hardlinkMock) : undefined,
    ignoreWhen: () => hardlink === null,
    onSuccess: (response) =>
      response.json().then((data: Hardlink) => {
        const app: AppId = {
          app: data.app,
          module: data.module,
          hasAccess: true
        }
        setCurrentApp(app, data.parameters)
      }),
    onError: () =>
      sendNotification(
        'warning',
        intl.formatMessage({
          id: 'ProfileOptions.HardlinkError',
          defaultMessage: 'Link is no longer available'
        })
      )
  })

  return <AppLauncher />
}
